import { hms, hmsToSec } from '@repo/lib/time/timeUtils';
import { CheckCircle2Icon, ChevronLeftIcon, PenLineIcon } from 'lucide-react';
import { Link, Navigate } from 'react-router';

import { Button } from '@/components/ui/button';
import { Form, FormControl, FormField, FormItem } from '@/components/ui/form';
import { TimeInput, TimeInputItem } from '@/components/ui/input';
import { InputGroup, InputGroupAddon, InputGroupInput } from '@/components/ui/input-group';
import { TimeInputClearButton } from '@/components/ui/input/time-input';
import { Tiptap, TiptapToolbar } from '@/components/ui/tiptap-editor';
import { useGetQuizTiptapExtensionBuilderSet, useQuizBuilderContentSection } from '@/hooks/quiz';

export default function QuizBuilderContentSectionPage() {
  const { form, onSubmit, sectionIndexNumber } = useQuizBuilderContentSection();
  const extensions = useGetQuizTiptapExtensionBuilderSet();

  if (sectionIndexNumber === undefined) {
    return <Navigate to="../questions" replace />;
  }

  return (
    <Form {...form}>
      <form noValidate onSubmit={form.handleSubmit(onSubmit)} className="flex h-full flex-col overflow-hidden">
        <div className="bg-card flex items-center gap-2 p-4">
          <Button variant="outline" asChild>
            <Link to={'../questions'}>
              <ChevronLeftIcon />
            </Link>
          </Button>
          <FormField
            name={'name'}
            render={({ field, fieldState }) => {
              return (
                <FormItem className="lg:max-w-52">
                  <FormControl>
                    <InputGroup className="w-full">
                      <InputGroupAddon align="inline-start">
                        <PenLineIcon className="text-muted-foreground" />
                      </InputGroupAddon>
                      <InputGroupInput {...field} aria-invalid={fieldState.error ? 'true' : 'false'} placeholder={'Nazwa sekcji'} />
                    </InputGroup>
                  </FormControl>
                </FormItem>
              );
            }}
          />
          <FormField
            name={'time'}
            render={({ field }) => {
              return (
                <FormItem className="max-w-44">
                  <FormControl>
                    <TimeInput disabled={field.disabled} value={hms(field.value)} onChange={(value) => field.onChange(hmsToSec(value))} inputProps={{ ...field }}>
                      <TimeInputItem picker="hours" onBlur={field.onBlur} />
                      <TimeInputItem picker="minutes" onBlur={field.onBlur} />
                      <TimeInputItem picker="seconds" onBlur={field.onBlur} ref={field.ref} />
                      <TimeInputClearButton />
                    </TimeInput>
                  </FormControl>
                </FormItem>
              );
            }}
          />
          <Button type="submit" className="ml-auto shrink-0">
            <CheckCircle2Icon />
            <span className="hidden sm:block">Zapisz sekcję</span>
          </Button>
        </div>
        <div className="flex flex-col gap-4 overflow-auto">
          <FormField
            name={'content'}
            render={({ field }) => (
              <FormControl className="pb-4">
                <Tiptap
                  extensions={extensions}
                  {...field}
                  placeholder="Treść sekcji..."
                  onUpdate={(res) => {
                    if (res.editor.isEmpty) {
                      field.onChange('');
                      return;
                    }
                    field.onChange(res.editor.getHTML());
                  }}
                  content={field.value}
                >
                  <TiptapToolbar className={'-top-px justify-start border-t p-3'} />
                </Tiptap>
              </FormControl>
            )}
          />
        </div>
      </form>
    </Form>
  );
}
